import {InjectionToken} from '@angular/core'
import {InfoEmbeddedService} from '@service/info/info.embedded.service'
import {InfoService} from '@service/info/info.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `InfoService`.
 *
 * @description
 * Devuelve `InfoEmbeddedService` en modo embebido y `InfoService` en
 * modo standalone. `InfoService` expone metadatos generales de la
 * aplicación y del usuario (versión, build, licencias, entorno)
 * consumidos por pantallas de ajustes y soporte.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `InfoService`.
 */
export function providerInfoServiceFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new InfoEmbeddedService() : new InfoService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `InfoService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerInfoServiceFactory}.
 */
export const InfoServiceToken = new InjectionToken<InfoService>('InfoService')
